import gql from 'graphql-tag';

export const typeDefs = undefined;
// export const typeDefs = gql`
//     extend type Query {
//     }
// `;

export const resolvers = {};